import { renderSlackMrkdwn } from '../lib/slack-mrkdwn';

/** RudderStack brand mark, inlined so it can take an arbitrary `currentColor`. */
function BrandMark({ className }: { className?: string }): React.ReactElement {
  return (
    <svg aria-hidden="true" viewBox="0 0 16 16" fill="none" className={className}>
      <path d="M15.8816 0H0C0 8.44808 6.57705 15.4359 15.0096 15.9471L15.8816 16V0Z" fill="currentColor" />
    </svg>
  );
}

interface SlackBubbleProps {
  channel: string;
  message: string;
}

/** A rendered Slack message bubble posted by the Lookout agent. */
export function SlackBubble({ channel, message }: SlackBubbleProps): React.ReactElement {
  // Slack prefixes public channels with "#" — mirror that unless the name already carries it.
  const channelName = channel && !channel.startsWith('#') ? `#${channel}` : channel;
  return (
    <div className="overflow-hidden rounded-lg border bg-background">
      <div className="border-b px-3 py-2 text-[0.8125rem] font-semibold text-foreground">{channelName}</div>
      <div className="flex gap-2.5 px-3 py-3">
        <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-md bg-primary">
          <BrandMark className="size-5 text-primary-foreground" />
        </span>
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <span className="text-[0.8125rem] font-bold text-foreground">Lookout</span>
            <span className="rounded bg-muted px-1 py-px text-[0.5625rem] font-bold tracking-wide text-muted-foreground uppercase">
              Agent
            </span>
          </div>
          <p className="mt-0.5 text-[0.8125rem] leading-relaxed whitespace-pre-wrap text-foreground">
            {renderSlackMrkdwn(message)}
          </p>
        </div>
      </div>
    </div>
  );
}
